import {Route} from './route.model';

export class TicketCreate {

    id: number;
    date: string;
    route_id: number;
    reservation_id: number;
    status: string;
    created: string;

    constructor(date: string, route_id: number, reservation_id: number, status: string) {
        this.date = date;
        this.route_id = route_id;
        this.reservation_id = reservation_id;
        this.status = status;
    }
}

export class Ticket {
    id: number;
    date: string;
    route: Route;
    route_id: number;
    reservation_id: number;
    status: string;
    constructor(id: number, date: string, route: Route, status: string) {
        this.id = id;
        this.date = date;
        this.route = route;
        this.status = status;
    }
}

export class TicketUpdate {
    id: number;
    date: string;
    route_id: number;
    reservation_id: number;
    route: Route;
    status: string;
    constructor(id: number, date: string, route_id: number, reservation_id: number, status: string) {
        this.id = id;
        this.date = date;
        this.route_id = route_id;
        this.reservation_id = reservation_id;
        this.status = status;
    }
}
